// extracted by mini-css-extract-plugin
export default {"adminContainer":"AdminBlogPage_adminContainer__tE8c4"};